import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCircleStore } from '../../stores/circle';
import { toast } from '../ui/Toast';
import { isStandalone } from '../../lib/pwa';
import { InstallGate } from './InstallGate';

export function CreateCircle() {
  const navigate = useNavigate();
  const createCircle = useCircleStore((s) => s.createCircle);
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);

  if (!isStandalone()) {
    return <InstallGate intent="create" />;
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await createCircle(name.trim() || undefined);
      navigate('/onboarding/invite', { replace: true });
    } catch (err) {
      toast(err instanceof Error ? err.message : 'Could not create circle', 'error');
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto flex min-h-screen max-w-screen-sm flex-col items-center justify-center bg-base px-6 text-text-primary">
      <h1 className="text-2xl font-medium">Create your circle</h1>
      <p className="mt-2 max-w-sm text-center text-sm text-text-muted">
        A circle is a small private group — you, your partner, maybe a couple of close people. Up to 6.
      </p>
      <form onSubmit={submit} className="mt-8 w-full max-w-xs">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={40}
          placeholder="Circle name (optional)"
          className="w-full rounded-xl border border-border-subtle bg-surface px-4 py-3 text-text-primary outline-none focus:border-sage"
        />
        <button
          type="submit"
          disabled={busy}
          className="mt-4 w-full rounded-xl bg-sage py-3 text-base font-medium text-white disabled:opacity-50"
        >
          {busy ? 'Creating…' : 'Create circle'}
        </button>
      </form>
    </div>
  );
}
